import NoResults from "components/Organisms/NoResults"
import React from "react"
import { inr } from "utils/formatters.utils"
import useOrderIds from "../add/useOrderIds"

export const Row = ({ name, value, className }) => {
  return (
    <div className={`grid grid-cols-12 gap-4 text-sm ${className}`}>
      <div className="col-span-6 vt-name text-right">{name} </div>
      <div className="col-span-1">:</div>
      <div className="col-span-4 vt-value text-left">{inr(value)}</div>
    </div>
  )
}
const InvoiceSummary = ({ invoice, trackingCode = null, children = null }) => {
  const orders = useOrderIds()
  const invItems = invoice?.invoiceItems ?? []
  const orderItems = []
  const taxes = []
  const ship = []
  for (const itm of invItems) {
    switch (itm.category) {
      case "ITEM":
        orderItems.push(itm)
        break
      case "TAXS":
        taxes.push(itm)
        break
      case "SHIP":
        ship.push(itm)
        break
      default:
        break
    }
  }

  const last = orderItems?.[orderItems?.length - 1]
  const lastInvItem = invItems[invItems.length - 1]
  return (
    <>
      {orderItems?.length > 0 ? (
        <>
          <table className="vt-bulk-update-summary-table pr-6">
            <thead className="vt-bulk-update-table-header">
              <tr>
                <th>Item</th>
                {orders?.length > 0 ? (
                  <>
                    <th>Quantity in DC</th>
                    <th>Added Quantity</th>
                    <th>Total Quantity</th>
                  </>
                ) : (
                  <th>Quantity</th>
                )}

                <th>Actual rate</th>
                <th>Discounted Rate</th>
                {/* <th>Balance</th> */}
                <th>Total</th>
              </tr>
            </thead>
            <tbody className="vt-bulk-update-table-body">
              {orderItems?.map?.((item, idx) => {
                return (
                  <tr key={idx}>
                    <td>{item?.name}</td>

                    {orders?.length > 0 ? (
                      <>
                        <td>{item?.stockCount ?? 0}</td>
                        <td>{item.quantity - (item?.stockCount ?? 0) ?? 0}</td>
                        <td>{item.quantity}</td>
                      </>
                    ) : (
                      <td>{item?.quantity ?? 0}</td>
                    )}

                    <td>{inr(item?.actualRate)}</td>
                    <td>{inr(item.discountedRate)}</td>

                    <td>{inr(item?.amount)}</td>
                  </tr>
                )
              })}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={4}></td>
                <td className="font-bold">{inr(last?.balance)}</td>
              </tr>
            </tfoot>
          </table>

          <div className="flex justify-between">
            {children}
            <section className="vt-invoice-summary">
              <Row className="mt-6" name="Sub-Total" value={last?.balance} />
              {ship?.map((s, idx) => (
                <Row
                  className="mt-2"
                  key={idx}
                  name={s?.name}
                  value={s?.amount}
                />
              ))}
              {taxes?.map((t, idx) => (
                <Row
                  key={idx}
                  className="mt-2"
                  name={t?.name}
                  value={t?.amount}
                />
              ))}
              <hr className="my-2" />
              <Row
                className="mt-2 vt-total"
                name="Grand Total"
                value={lastInvItem.balance}
              />
            </section>
          </div>
        </>
      ) : (
        <NoResults
          icon="cross"
          title="No order items"
          description={`Order ${trackingCode} does not contain any items`}
        />
      )}
    </>
  )
}

export default InvoiceSummary
